import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import SingleSelect from "../../common/SingleSelect";
import Checkbox from "../../common/Checkbox";
import Button from "../../common/Button";
import { timeZonesTypes } from "../../Attributes/timezone";
import { measurementStandard, currencies } from "../../Users/userDataTypes";

const AttributesSection = (props) => (
  <Fragment>
                  <h4 style={{ margin: "10px 0" }}>
                    {props.translate("sharedAttributes")}
                  </h4>
                  <Grid container spacing={2}>
                    {/* <Grid item sm={3} xs={12}>
                    <TextField
                      id='web.liveRouteLength'
                      label={props.translate('attributeWebLiveRouteLength')}
                      placeholder=''
                      type='number'
                      value={
                        (props.form.attributes &&
                          props.form.attributes['web.liveRouteLength']) ||
                        ''
                      }
                      onChange={e =>
                        props.changeAttribute2('web.liveRouteLength', e)
                      }
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid> */}
                    {/* <Grid item sm={3} xs={12}>
                    <TextField
                      id='web.maxZoom'
                      type='number'
                      label={props.translate('attributeWebMaxZoom')}
                      placeholder=''
                      value={
                        (props.form.attributes &&
                          props.form.attributes['web.maxZoom']) ||
                        ''
                      }
                      onChange={e =>
                        props.changeAttribute2('web.maxZoom', e)
                      }
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid> */}
                    {/* <Grid item sm={3} xs={12}>
                    <TextField
                      id='web.selectZoom'
                      type='number'
                      label={props.translate('attributeWebSelectZoom')}
                      placeholder=''
                      value={
                        (props.form.attributes &&
                          props.form.attributes['web.selectZoom']) ||
                        ''
                      }
                      onChange={e =>
                        props.changeAttribute2('web.selectZoom', e)
                      }
                      variant='outlined'
                      margin='dense'
                      fullWidth
                    />
                  </Grid> */}
                    <Grid item sm={3} xs={12}>
                      <SingleSelect
                        array={props.defaultZones}
                        async
                        selectName="timezone"
                        isClearable
                        // defaultOptions={props.defaultZones}
                        loadOptions={props.searchFromZoneList}
                        label={props.translate("sharedTimezone")}
                        value={
                          props.form.attributes &&
                          props.form.attributes["timezone"]
                            ? timeZonesTypes.find(
                                (t) =>
                                  t.key === props.form.attributes.timezone,
                              )
                            : ""
                        }
                        handleChange={props.timezone_handleChange}
                        canAssign={true}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id="measurementStandard"
                        select
                        label={props.translate("measurementStandard")}
                        value={
                          (props.form.attributes &&
                            props.form.attributes.measurementStandard) ||
                          ""
                        }
                        onChange={(e) =>
                          props.changeAttribute2("measurementStandard", e)
                        }
                        SelectProps={{
                          MenuProps: {
                            className: props.classes.menu,
                          },
                        }}
                        margin="dense"
                        fullWidth
                      >
                        {measurementStandard.map((option) => (
                          <MenuItem key={option.key} value={option.key}>
                            {props.translate(option.value)}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      sm={6}
                      md={4}
                      xs={12}
                      style={{ marginTop: 0, maxWidth: "25%" }}
                    >
                      <TextField
                        id="currencyLabel"
                        select
                        label={props.translate("currencies")}
                        value={
                          (props.form.attributes &&
                            props.form.attributes.currencyLabel) ||
                          ""
                        }
                        onChange={(e) =>
                          props.changeAttribute2("currencyLabel", e)
                        }
                        SelectProps={{
                          MenuProps: {
                            className: props.classes.menu,
                          },
                        }}
                        margin="dense"
                        fullWidth
                      >
                        {currencies &&
                          currencies.map((option) => (
                            <MenuItem key={option.key} value={option.value}>
                              {props.translate(option.key)}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    <Grid item xl={3} sm={6} md={4} xs={12}>
                      <Checkbox
                        checked={
                          props.form.attributes &&
                          props.form.attributes.viewModel
                        }
                        onChange={(e) =>
                          props.changeAttribute2("viewModel", e)
                        }
                        canAssign
                        canRemove
                        label={props.translate("viewModel")}
                      />
                    </Grid>
                    {props?.form?.attributes?.images?.map(
                      (imageUrl, key) => (
                        <Grid item sm={6} xs={12} key={key}>
                          <div
                            style={{
                              display: "inline-flex",
                              flexWrap: "wrap",
                              marginTop: "15px",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                margin: "0 15px 15px 0",
                              }}
                            >
                              <Tooltip
                                placement="right-end"
                                title={props.translate("clickForPreview")}
                              >
                                <img
                                  style={{
                                    width: 120,
                                    height: "100px",
                                    cursor: "pointer",
                                  }}
                                  alt={`driverImage-${key}`}
                                  src={
                                    `data:image/jpeg;base64,${imageUrl?.data}` ||
                                    ""
                                  }
                                  // onClick={() => props.imagePopup(props.form.driverImg[key])}
                                />
                              </Tooltip>
                              <CloseIcon
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  right: "-10px",
                                  cursor: "pointer",
                                  zIndex: "99",
                                  background: "#fff",
                                  borderRadius: "50%",
                                }}
                                onClick={() => props.removeImage(key)}
                              />
                            </div>
                          </div>
                        </Grid>
                      ),
                    )}

                    <Grid item xl={3} sm={6} md={4} xs={12}>
                      <Checkbox
                        checked={
                          props.form.attributes &&
                          props.form.attributes.viewIMEI
                        }
                        onChange={(e) =>
                          props.changeAttribute2("viewIMEI", e)
                        }
                        canAssign
                        canRemove
                        label={props.translate("viewIMEI")}
                      />
                    </Grid>
                    {props.form.userType === 3 && (
                      <Grid item xl={3} sm={6} md={4} xs={12}>
                        <Checkbox
                          checked={
                            props.accountsform.accountControl || false
                          }
                          onChange={props.handleChangeAttributes(
                            "accountControl",
                          )}
                          canAssign
                          canRemove
                          label={props.translate("accountControl")}
                        />
                      </Grid>
                    )}
                    {props.form.userType === 1 && (
                      <>
                        <Grid item xl={3} sm={6} md={4} xs={12}>
                          <Checkbox
                            checked={
                              props.form.attributes &&
                              props.form.attributes.isDriverActive
                            }
                            onChange={(e) =>
                              props.changeAttribute2("isDriverActive", e)
                            }
                            canAssign
                            canRemove
                            label={props.translate("isDriverActive")}
                          />
                        </Grid>
                        {props.form.attributes?.isDriverActive && (
                          <Grid
                            item
                            sm={6}
                            md={3}
                            xs={12}
                            style={{ zIndex: 99 }}
                          >
                            <SingleSelect
                              array={props.defaultVehiclesList || []}
                              async
                              selectName="vehicleId"
                              isClearable
                              loadOptions={props.searchVehicleList.bind()}
                              label={
                                <p style={{ fontSize: "0.9rem" }}>
                                  {props.translate("searchVehicle")}
                                </p>
                              }
                              value={
                                props.selectedVehicle &&
                                props.selectedVehicle.id
                                  ? {
                                      id: props.selectedVehicle.id,
                                      value: props.selectedVehicle.id,
                                      label: props.selectedVehicle.name,
                                    }
                                  : "searchVehicle"
                              }
                              handleChange={props.timezone_handleChange}
                              canAssign={true}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </Grid>
                        )}
                      </>
                    )}

                    {/* {props.form.attributes && props.form.attributes.measurementStandard &&
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id='distanceUnit'
                        select
                        label={props.translate('settingsDistanceUnit')}
                        value={
                          (props.form.attributes &&
                            props.form.attributes.distanceUnit) ||
                          ''
                        }
                        onChange={e =>
                          props.changeAttribute2('distanceUnit', e)
                        }
                        SelectProps={{
                          MenuProps: {
                            className: props.classes.menu
                          }
                        }}
                        margin='dense'
                        fullWidth
                      >
                        {checkUnitsWithStandardType(
                          props.form.attributes.measurementStandard, 'distanceUnit').map(option => (
                            <MenuItem key={option.key} value={option.key}>
                              {props.translate(option.name)}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>}
                  {props.form.attributes && props.form.attributes.measurementStandard &&
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id='speedUnit'
                        select
                        label={props.translate('settingsSpeedUnit')}
                        value={
                          (props.form.attributes &&
                            props.form.attributes.speedUnit) ||
                          ''
                        }
                        onChange={e => props.changeAttribute2('speedUnit', e)}
                        SelectProps={{
                          MenuProps: {
                            className: props.classes.menu
                          }
                        }}
                        margin='dense'
                        fullWidth
                      >
                        {checkUnitsWithStandardType(
                          props.form.attributes.measurementStandard, 'speedUnit').map(option => (
                            <MenuItem key={option.key} value={option.key}>
                              {props.translate(option.name)}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>}
                  {props.form.attributes && props.form.attributes.measurementStandard &&
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id='volumeUnit'
                        select
                        label={props.translate('settingsVolumeUnit')}
                        value={
                          (props.form.attributes &&
                            props.form.attributes.volumeUnit) ||
                          ''
                        }
                        onChange={e => props.changeAttribute2('volumeUnit', e)}
                        SelectProps={{
                          MenuProps: {
                            className: props.classes.menu
                          }
                        }}
                        margin='dense'
                        fullWidth
                      >
                        {checkUnitsWithStandardType(
                          props.form.attributes.measurementStandard, 'volumeUnit').map(option => (
                            <MenuItem key={option.key} value={option.key}>
                              {props.translate(option.name)}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>} */}
                  </Grid>
                  <Grid container spacing={2}>
                    {props.editOption ? (
                      <Grid item md={6} sm={4} xs={6}>
                        <div className="license-card clearfix">
                          <Grid container spacing={16}>
                            <Grid item xs={12}>
                              <label style={{ fontSize: 10 }}>
                                {props.translate("userToken")}
                              </label>
                              <Tooltip title={props.translate("getToken")}>
                                <Button
                                  className="pull-right button-white"
                                  onClick={props.generateToken}
                                >
                                  {<RefreshIcon />}
                                </Button>
                              </Tooltip>
                              <p onClick={(e) => props.selectMe(e)}>
                                <code style={{ wordBreak: "break-all" }}>
                                  {props.form.token &&
                                    props.ServerSetting &&
                                    props.ServerSetting.attributes &&
                                    (props.ServerSetting.attributes
                                      .adminUrl +
                                      "/login?&" +
                                      btoa(props.form.token) ||
                                      "")}
                                </code>
                              </p>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    ) : (
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          label={props.translate("userToken")}
                          value={props.form.token || ""}
                          onChange={props.handleChange("Token")}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title={props.translate("getToken")}
                                >
                                  <IconButton
                                    onClick={props.generateToken}
                                  >
                                    {<RefreshIcon />}
                                  </IconButton>
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {props.form.token && (
                          <Tooltip title={props.translate("setNoToken")}>
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => props.setNoToken(e)}
                            >
                              {props.translate("noToken")}
                            </a>
                          </Tooltip>
                        )}
                      </Grid>
                    )}
                  </Grid>
  </Fragment>
);

export default AttributesSection;
